export default __webpack_public_path__ + "img/tOitJupU.f64126b6.svg";